/* generated by Svelte v3.9.1 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	text
} from "svelte/internal";
import { createEventDispatcher } from "svelte"

function add_css() {
	var style = element("style");
	style.id = 'svelte-1ovynke-style';
	style.textContent = "button.svelte-1ovynke{flex:1}";
	append(document.head, style);
}

function create_fragment(ctx) {
	var button, t, dispose;

	return {
		c() {
			button = element("button");
			t = text("Reset");
			attr(button, "title", ALT_TEXT);
			attr(button, "class", "svelte-1ovynke");
			dispose = listen(button, "click", ctx.resetGame);
		},

		m(target, anchor) {
			insert(target, button, anchor);
			append(button, t);
		},

		p: noop,
		i: noop,
		o: noop,

		d(detaching) {
			if (detaching) {
				detach(button);
			}

			dispose();
		}
	};
}

const ALT_TEXT = 'Refresh Game'

function instance($$self) {
	const dispatch = createEventDispatcher()

  const resetGame = () => {
    dispatch('reset')
  }

	return { resetGame };
}

class Component extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1ovynke-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, []);
	}
}

export default Component;